import React, { useEffect } from "react";
import "./HorizontalSlider.css";

const HorizontalSlider = ({
  data,
  renderComponent,
  heading,
  scaleWidth,
  minHeight,
  hideSlideButtons,
  hideDots = false,
}) => {
  if (!scaleWidth) scaleWidth = 1;
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [isHovered, setIsHovered] = React.useState(0);
  const changeSlide = (where) => {
    let tmp = activeIndex;
    if (where === "left") tmp--;
    if (where === "right") tmp++;
    if (tmp < 0) tmp = data.length - 1;
    if (tmp >= data.length) tmp = 0;
    setActiveIndex(tmp);
  };

  const getTranslateValue = (i) => {
    if (i - 1 >= 0 && i - 1 === activeIndex) return 10;
    if (i + 1 < data.length && i + 1 === activeIndex) return -10;
    if (activeIndex === 0 && i === data.length - 1) return -10;
    if (activeIndex === data.length - 1 && i === 0) return 10;
    return 0;
  };

  useEffect(() => {
    let cancleIntervel;
    if (!isHovered) {
      cancleIntervel = setInterval(() => {
        setActiveIndex((pval) => (pval + 1) % data.length);
      }, 4000);
    }
    return () => {
      if (cancleIntervel) {
        clearInterval(cancleIntervel);
      }
    };
  }, [isHovered]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: "",
        minHeight: { minHeight },
        cursor: "pointer",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          margin: "",
          fontSize: "2.5rem",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {heading}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          width: `${100 * scaleWidth}vw`,
        }}
      >
        <div
          style={{
            width: `${80 * scaleWidth}vw`,
            minWidth: "320px",
            position: "relative",
            alignItems: "center",
          }}
        >
          {data.map((sdata, i) => (
            <div
              key={`slider-${i}`}
              style={{
                display: "flex",
                minWidth: `60%`,
                justifyContent: "center",
                alignItems: "center",
                position: i === activeIndex ? "static" : "absolute",
                transitionDuration: ".6s",
                opacity: i === activeIndex ? 1 : 0,
                transform:
                  i === activeIndex
                    ? "translateX(0px)"
                    : `translateX(${getTranslateValue(i)}%)`,
                zIndex: 10,
              }}
            >
              {i !== activeIndex ? null : renderComponent(sdata, i)}
            </div>
          ))}
        </div>
        {/* left arrow */}
        {window.screen.availWidth <= 993 || hideSlideButtons ? null : (
          <div
            className="arrowsSlider left"
            style={{
              "--dis":
                window.screen.availWidth < 393
                  ? 1
                  : window.screen.availWidth < 693
                  ? 10
                  : 20,
            }}
            onClick={() => changeSlide("left")}
          >
            &#8592;
          </div>
        )}
        {/* right arrow */}
        {window.screen.availWidth <= 993 || hideSlideButtons ? null : (
          <div
            className="arrowsSlider right"
            style={{
              "--dis":
                window.screen.availWidth < 393
                  ? 1
                  : window.screen.availWidth < 693
                  ? 6
                  : 20,
            }}
            onClick={() => changeSlide("right")}
          >
            &#8594;
          </div>
        )}
      </div>
      <div
        style={{
          display: `${window.screen.availWidth <= 993 ? "none" : "flex"}`,
          justifyContent: "center",
        }}
      >
        {data.map((s, i) => (
          <div
            className="shadowCss"
            onClick={() => setActiveIndex(i)}
            key={`dots-${i}`}
            style={{
              margin: "10px 5px",
              height: "15px",
              width: "15px",
              borderRadius: "50%",
              borderWidth: "2px",
              borderColor: `rgba(59, 130, 246,${i !== activeIndex ? 0 : 0})`,
              backgroundColor:
                i !== activeIndex ? "#d0d0d0" : "rgba(59, 130, 246,0.7)",
              transitionDuration: ".7s",
              cursor: "pointer",
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalSlider;
